import { useEffect, useRef, useState } from 'react';

interface IAudioPlayer {
    isPlaying: boolean;
    togglePlay: () => void;
}

const useAudioPlayer = (src?: string | null): IAudioPlayer => {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef<HTMLAudioElement | null>(null);

    useEffect(() => {
        setIsPlaying(false);

        return () => {
            audioRef.current?.pause();
            audioRef.current = null;
        };
    }, [src]);

    const togglePlay = (): void => {
        if (!src) {
            return;
        }

        if (!audioRef.current) {
            audioRef.current = new Audio(src);
            audioRef.current.onended = () => setIsPlaying(false);
            audioRef.current.onerror = () => setIsPlaying(false);
        }

        if (isPlaying) {
            audioRef.current.pause();
            setIsPlaying(false);

            return;
        }

        audioRef.current.currentTime = 0;
        audioRef.current.play()
            .then(() => setIsPlaying(true))
            .catch(() => setIsPlaying(false));
    };

    return { isPlaying: isPlaying, togglePlay: togglePlay };
};

export { useAudioPlayer };
